<div class="custom-scrollbar" style="padding: 0px 10rem;margin:auto;max-height: calc(100vh - 80px);overflow-y: scroll;">
    <app-detail #detail [setComponentId]='componentId'></app-detail>
</div>
